export const selectLastPushNotification = (state) => state.root.notifications.notification;
export const selectReloadAt = (state) => state.root.notifications.resumeAt;
export const selectUnreadEvents = (state) => state.root.notifications.unreadCount;
